import * as Tgcc from '../tgccGlobal';
import * as React from 'react';
import Radium, { StyleRoot } from 'radium';
import {CSSProperties} from 'react';
import {connect} from 'react-redux';


const wrapperStyle : CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: '0 5px 5px 5px',
    fontFamily: 'CenturyGothic',
    boxShadow: Tgcc.Styles.boxShadow,
    fontSize: '8px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    margin: '5px',
    height:'255px',
    transition:'transform 250ms',
    ':hover': {
        transform:'translateY(-10px)'
    },
     '@media (max-width:800px) and (max-height:1280px)': {
        margin:'10px auto'
    },
    '@media (max-width:768px) and (max-height:1366px)': {
        margin:'10px auto'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        margin:'10px auto'
    },
    '@media (max-width:414px)': {
        margin:'auto auto 10px auto'
    }
};


const logoTextStyle : CSSProperties = {
    alignSelf: 'center',
    height: '20px',
    lineHeight: '20px',
    margin: '5px',
    fontFamily: 'CenturyGothic',
    fontSize: '10px',
    letterSpacing: '3px',
    display: 'none'
};
const contentStyle : CSSProperties = {
    position: 'relative',
    height: '230px',
    width:'220px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    fontFamily:'BarlowLight',
    justifyContent: 'space-between'
};
const styleStyle : CSSProperties = {
    alignSelf: 'flex-start',
    fontSize: '14px',
    letterSpacing: '3px',
    maxWidth: '100%',
    color:'#606060',
    fontFamily:'BarlowLight'
};
const styleNoPicStyle : CSSProperties = {
    alignSelf: 'center',
    height: '40px',
    fontSize: '24px',
    lineHeight: '40px',
    letterSpacing: '5px'
};
const imageStyle : CSSProperties = {
    alignSelf: 'center',
    maxWidth: '80%',
    maxHeight: '65%',
    cursor: 'pointer',
};

const descGrpStyle: CSSProperties = {
    alignSelf: 'flex-start',
}

const descStyle: CSSProperties = {
    alignSelf:'flex-start',
    color:'#606060',
    fontSize:'10px',
    fontFamily:'BarlowLight'

}

const brandStyle: CSSProperties = {
    alignSelf: 'flex-start',
    color:'#606060',
    fontSize: '14px',
    fontFamily:'BarlowMedium'
}

class CardProps{
    product: Tgcc.Product;
    brand: Tgcc.ProductBrand;
    onSelect?: (product : Tgcc.Product) => void;
    onClick?:() => void;
}

class _CampusProductCard extends React.Component<CardProps,any> {

    handleSelection = (evt) => {
        if (this.props.onSelect){ 
            this.props.onSelect(this.props.product);
        }
        if(this.props.onClick) {
            this.props.onClick()
        }
    }

    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
    }

    handleMissingLogo =  (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.style.display='none';
        var el: HTMLElement = event.currentTarget.nextSibling as HTMLElement;
        let style = el.attributes['style'].value.replace('display: none;','display: flex;');
        el.attributes['style'].value=style;
    }
    
    render() {
        let cardHeader = null;
        let cardImage = this.props.product.thumbnail;
        let cardStyle = this.props.product.style;
        let description = this.props.product.description;
        let brand = this.props.product.brand;
        return (
            <div style={wrapperStyle}>
                <div style={contentStyle} onClick={this.handleSelection}>
                    <img style={imageStyle} src={Tgcc.getProductPath(cardImage.replace(' ', '%20'))} onError={this.handleImageError} />
                    <div style={descGrpStyle}>
                        <div style={brandStyle}>{brand}</div>
                        <div style={styleStyle}>{cardStyle}</div>
                        <div style={descStyle}>{description}</div>
                    </div>
                </div>
            </div>
        )
    }
}
export var CampusProductCard = Radium(_CampusProductCard);

